import React from "react";
import { Box } from "@mui/material";
import ChartImageExportCard from "./ChartImageExportCard";
import RiskBarChart from "./RiskBarChart";
import ReportingCategoryDateChart from "./ReportingCategoryDateChart";
import TPerformanceChart from "./TPerformanceChart";
import MissionChart from "./Missionchart";
import GuestChart from "./Guestchart";
import EstimatedTimeChart from "./EstimatedTimeChart";
import { showMissionGuest, showEstimated } from "../utils/constants";

const HiddenExportLayers = ({
  incidentChartGroups,
  assignNodeRef,
  incidentImageExportRefs,
  incidentReportingImageExportRefs,
  tPerformanceImageExportRefs,
  incidentExportRefs,
  incidentReportingExportRefs,
  tPerformanceExportRefs,
  missionExportRef,
  guestExportRef,
  estimatedExportRef,
  showReportingCategory,
  hasRiskReportingCategoryFilter,
  isPrototypeGrouped,
  lang,
  organizationId,
  showIncidentYellow,
  showIncidentRed,
  includeTrainingData,
  includeReadData,
  dateFrom,
  dateTo,
  buildImageHeaderRows,
  buildRiskImageDetailRows,
  buildReportingImageDetailRows,
  buildPerformanceImageDetailRows,
  missionFiltered,
  guestFiltered,
  estimatedFiltered,
  mDateFrom,
  mDateTo,
  mTimeRange,
  mSetNumbers,
  mShowGreen,
  mShowYellow,
  mShowRed,
  setMDateFrom,
  setMDateTo,
  setMTimeRange,
  setMSetNumbers,
  setMShowGreen,
  setMShowYellow,
  setMShowRed,
  gDateFrom,
  gDateTo,
  gTimeRange,
  gSetNumbers,
  setGDateFrom,
  setGDateTo,
  setGTimeRange,
  setGSetNumbers,
  eDateFrom,
  eDateTo,
  eTimeRange,
  eSetNumbers,
  eBeach,
  setEDateFrom,
  setEDateTo,
  setETimeRange,
  setESetNumbers,
  setEBeach,
}) => (
  <>
    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        transform: "translateX(-240vw)",
        pointerEvents: "none",
        opacity: 0,
        zIndex: -1,
      }}
    >
      {incidentChartGroups.map((group) => {
        const riskSubtitle = [
          lang === "dk" ? "Faktisk hændelse" : "Real Incident",
          isPrototypeGrouped ? group.title : "",
        ]
          .filter(Boolean)
          .join(" - ");
        const reportingSubtitle = [
          "PreVent Data",
          isPrototypeGrouped ? group.title : "",
        ]
          .filter(Boolean)
          .join(" - ");
        const performanceSubtitle = [
          "T-Performance",
          isPrototypeGrouped ? group.title : "",
        ]
          .filter(Boolean)
          .join(" - ");

        return (
          <Box key={`image-export-${group.key}`}>
            <div
              ref={(node) =>
                assignNodeRef(incidentImageExportRefs, group.key, node)
              }
              style={{ background: "#fff" }}
            >
              <ChartImageExportCard
                title="Action-cards® til sikker førstehjælp"
                subtitle={riskSubtitle}
                headerRows={buildImageHeaderRows()}
                detailRows={buildRiskImageDetailRows()}
              >
                <RiskBarChart
                  defaultRecords={group.defaultRecords}
                  reportingCategoryRecords={group.reportingCategoryRecords}
                  trainingRecords={group.trainingRecords}
                  readRecords={group.readRecords}
                  organizationId={organizationId}
                  showIncidentYellow={showIncidentYellow}
                  showIncidentRed={showIncidentRed}
                  showMinInjuriesBar
                  showTraining={includeTrainingData}
                  showRead={includeReadData}
                  actionCards={group.actionCards}
                  lang={lang}
                  height={860}
                />
              </ChartImageExportCard>
            </div>

            {showReportingCategory && hasRiskReportingCategoryFilter ? (
              <div
                ref={(node) =>
                  assignNodeRef(
                    incidentReportingImageExportRefs,
                    group.key,
                    node,
                  )
                }
                style={{ background: "#fff" }}
              >
                <ChartImageExportCard
                  title="Action-cards® til sikker førstehjælp"
                  subtitle={reportingSubtitle}
                  headerRows={buildImageHeaderRows()}
                  detailRows={buildReportingImageDetailRows()}
                >
                  <ReportingCategoryDateChart
                    records={group.reportingCategoryRecords}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    showNearMiss
                    showPrevention
                    showDoubtAboutReporting
                    lang={lang}
                    height={860}
                  />
                </ChartImageExportCard>
              </div>
            ) : null}

            <div
              ref={(node) =>
                assignNodeRef(tPerformanceImageExportRefs, group.key, node)
              }
              style={{ background: "#fff" }}
            >
              <ChartImageExportCard
                title="Action-cards® til sikker førstehjælp"
                subtitle={performanceSubtitle}
                headerRows={buildImageHeaderRows()}
                detailRows={buildPerformanceImageDetailRows()}
              >
                <TPerformanceChart
                  records={group.performanceRecords}
                  actionCards={group.actionCards}
                  lang={lang}
                  height={860}
                />
              </ChartImageExportCard>
            </div>
          </Box>
        );
      })}
    </Box>

    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        transform: "translateX(-200vw)",
        width: "1400px",
        pointerEvents: "none",
        opacity: 0,
        background: "#fff",
        zIndex: -1,
      }}
    >
      {incidentChartGroups.map((group) => (
        <div key={`incident-export-${group.key}`}>
          <div
            ref={(node) => assignNodeRef(incidentExportRefs, group.key, node)}
            style={{ width: "1600px", height: "920px" }}
          >
            <RiskBarChart
              defaultRecords={group.defaultRecords}
              reportingCategoryRecords={group.reportingCategoryRecords}
              trainingRecords={group.trainingRecords}
              readRecords={group.readRecords}
              organizationId={organizationId}
              showIncidentYellow={showIncidentYellow}
              showIncidentRed={showIncidentRed}
              showMinInjuriesBar
              showTraining={includeTrainingData}
              showRead={includeReadData}
              actionCards={group.actionCards}
              lang={lang}
              height={900}
            />
          </div>

          {showReportingCategory && hasRiskReportingCategoryFilter ? (
            <div
              ref={(node) =>
                assignNodeRef(incidentReportingExportRefs, group.key, node)
              }
              style={{ width: "1600px", height: "920px" }}
            >
              <ReportingCategoryDateChart
                records={group.reportingCategoryRecords}
                dateFrom={dateFrom}
                dateTo={dateTo}
                showNearMiss
                showPrevention
                showDoubtAboutReporting
                lang={lang}
                height={900}
              />
            </div>
          ) : null}

          <div
            ref={(node) =>
              assignNodeRef(tPerformanceExportRefs, group.key, node)
            }
            style={{ width: "1600px", height: "920px" }}
          >
            <TPerformanceChart
              records={group.performanceRecords}
              actionCards={group.actionCards}
              lang={lang}
              height={900}
            />
          </div>
        </div>
      ))}

      {showMissionGuest(organizationId) && (
        <div
          ref={missionExportRef}
          style={{ width: "1400px", height: "430px" }}
        >
          <MissionChart
            data={missionFiltered}
            organizationId={organizationId}
            lang={lang}
            hideFilters
            externalFilters={{
              dateFrom: mDateFrom,
              dateTo: mDateTo,
              timeRange: mTimeRange,
              setNumbers: mSetNumbers,
              showGreen: mShowGreen,
              showYellow: mShowYellow,
              showRed: mShowRed,
              setDateFrom: setMDateFrom,
              setDateTo: setMDateTo,
              setTimeRange: setMTimeRange,
              setSetNumbers: setMSetNumbers,
              setShowGreen: setMShowGreen,
              setShowYellow: setMShowYellow,
              setShowRed: setMShowRed,
            }}
          />
        </div>
      )}

      {showMissionGuest(organizationId) && (
        <div ref={guestExportRef} style={{ width: "1400px", height: "430px" }}>
          <GuestChart
            data={guestFiltered}
            organizationId={organizationId}
            lang={lang}
            hideFilters
            externalFilters={{
              dateFrom: gDateFrom,
              dateTo: gDateTo,
              timeRange: gTimeRange,
              setNumbers: gSetNumbers,
              setDateFrom: setGDateFrom,
              setDateTo: setGDateTo,
              setTimeRange: setGTimeRange,
              setSetNumbers: setGSetNumbers,
            }}
          />
        </div>
      )}

      {showEstimated(organizationId) && (
        <div
          ref={estimatedExportRef}
          style={{ width: "1400px", height: "430px" }}
        >
          <EstimatedTimeChart
            data={estimatedFiltered}
            organizationId={organizationId}
            lang={lang}
            hideFilters
            externalFilters={{
              dateFrom: eDateFrom,
              dateTo: eDateTo,
              timeRange: eTimeRange,
              setNumbers: eSetNumbers,
              beach: eBeach,
              setDateFrom: setEDateFrom,
              setDateTo: setEDateTo,
              setTimeRange: setETimeRange,
              setSetNumbers: setESetNumbers,
              setBeach: setEBeach,
            }}
          />
        </div>
      )}
    </Box>
  </>
);

export default HiddenExportLayers;
